(() => {
  const config = document.getElementById('holiday-cart-copy');
  if (!config) return;
  const heading = config.dataset.heading;
  let connected = false;
  let attempts = 0;
  const connect = () => {
    if (connected) return true;
    const root = document.getElementById('aftersell-cart-root')?.shadowRoot;
    if (!root) return false;
    connected = true;
    const update = () => {
      root.querySelectorAll('.cart-internal-upsells__heading strong, .cart-external-upsells__heading strong').forEach(el => {
        if (el.textContent.trim() === 'You may also like') el.textContent = heading;
      });
    };
    update();
    new MutationObserver(update).observe(root, {childList: true, subtree: true, characterData: true});
    document.removeEventListener('click', onInteraction);
    return true;
  };
  const onInteraction = () => { setTimeout(connect, 250); };
  if (!connect()) {
    const timer = setInterval(() => {
      attempts += 1;
      if (connect() || attempts >= 150) clearInterval(timer);
    }, 200);
    document.addEventListener('click', onInteraction, {passive: true});
  }
})();

